// サムネイル専用：ボタンでだけループするシンプル版
class ThumbnailLoopSliderComponent extends SliderComponent {
  constructor() {
    super(); // SliderComponent の constructor（prev/next のイベント登録など）を全部使う
    if (!this.slider) return;

    // 親クラスの「端でボタンを disabled にする」機能をオフ
    this.enableSliderLooping = true;
    // super() 中で付けられた disabled をリセット
    if (this.prevButton) this.prevButton.removeAttribute('disabled');
    if (this.nextButton) this.nextButton.removeAttribute('disabled');
    
  }

  // ボタンクリック時だけ「前後ループ」するように上書き
  onButtonClick(event) {
    event.preventDefault();

    if (!this.sliderItemsToShow || this.sliderItemsToShow.length === 0) return;
    if (!this.sliderItemOffset) return;

    const step = Number(event.currentTarget.dataset.step || 1);

    // 今どのインデックスにいるか（サムネイルの先頭を 0 としたインデックス）
    const baseOffset = this.sliderItemsToShow[0].offsetLeft;
    const currentIndex = Math.round((this.slider.scrollLeft - baseOffset) / this.sliderItemOffset);

    // 1ページに何枚見えているか（既に SliderComponent が計算済み）
    const perPage = this.slidesPerPage || 1;

    // 最後のページの「先頭インデックス」
    const maxIndex = Math.max(0, this.sliderItemsToShow.length - perPage);

    let targetIndex;

    if (event.currentTarget.name === 'next') {
      // 次へ：ステップ分進む → はみ出したら先頭へ
      targetIndex = currentIndex + step;
      if (targetIndex > maxIndex) {
        targetIndex = 0;
      }
    } else {
      // 前へ：ステップ分戻る → 0 より小さくなったら最後へ
      targetIndex = currentIndex - step;
      if (targetIndex < 0) {
        targetIndex = maxIndex;
      }
    }

    const targetLeft = baseOffset + targetIndex * this.sliderItemOffset;

    this.setSlidePosition(targetLeft);
  }
}

// <thumbnail-loop-slider> タグに紐づけ
customElements.define('thumbnail-loop-slider', ThumbnailLoopSliderComponent);
